<template>
  <div class="white-container info-edit">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small" label-position="left">
      <el-form-item label="店铺名称" prop="name" style="width:800px">
        <el-input v-model="form.name" width="300" placeholder="请填写店铺名称" style="width: 300px !important;" />
      </el-form-item>
      <el-form-item label="选择城市" prop="uaEventCityId" style="width:300px">
        <el-select v-model="form.uaEventCityId" placeholder="请选择城市">
          <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <div class="flex" style="flex-wrap:wrap;">
        <el-form-item label="店铺地址" prop="address">
          <el-input v-model="form.address" placeholder="请填写店铺地址" style="width: 300px !important;" />
        </el-form-item>
        <el-form-item style="margin-left:20px;margin-right:20px;" class="btn-form-item">
          <el-button type="primary" @click="openMap">点开地图</el-button>
        </el-form-item>
        <el-form-item label="坐标" prop="location" width="50" class="lng-label">
          <el-input v-model="form.location" placeholder="请填写经纬度" style="width: 200px !important;" />
        </el-form-item>
      </div>

      <el-form-item style="width:100%;margin-top:80px;margin-left:-50px">
        <div class="flex btns">
          <el-button type="info" @click="cancel">取消</el-button>
          <el-button type="primary" @click="submit">保存</el-button>
        </div>
      </el-form-item>
    </el-form>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="goBack" />
  </div>
</template>
<script>
import { ActivityStore } from '@/model/ActivityStore';
import Dialog from '@/components/Dialog';

export default {
  components: { Dialog },
  data() {
    return {
      form: new ActivityStore(),
      rules: {
        name: [
          { required: true, message: '请填写店铺名称', trigger: 'blur' },
        ],
        uaEventCityId: [
          { required: true, message: '请选择城市', trigger: 'change' },
        ],
        address: [
          { required: true, message: '请填写店铺地址', trigger: 'blur' },
        ],
        location: [
          {
            required: true, validator: (rule, value, callback) => {
              if (value === '0,0') {
                callback(new Error('请输入经纬度'));
              } else {
                callback();
              }
            }, trigger: 'blur',
          },
        ],

      },
      formDialogShow: false,
      information: {},
    };
  },
  computed: {
    cityList() {
      return this.$store.state.activity.citySelectVO;
    },
  },
  mounted() {
    const { query } = this.$route;
    if (query.id) {
      this.getAddressDetail(query.id);
    }
  },
  methods: {
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.addAddress();
        } else {
          return false;
        }
      });
    },
    getAddressDetail(id) {
      this.$Api.activity.addressDetails(id).then(res => {
        console.log(res);
        this.form = new ActivityStore(res);
        this.location = {
          lat: res.latitude,
          lng: res.longitude,
        };
      });
    },
    addAddress() {
      console.info(this.form);
      this.$Api.activity.addAddress(this.form).then(res => {
        if (this.form.id) {
          this.$message.success('编辑成功');
        } else {
          this.$message.success('保存成功');
        }
        setTimeout(() => {
          this.goBack();
        }, 2000);
      });
    },
    openMap() {
      window.open('https://lbs.qq.com/getPoint/');
    },
    cancel() {
      this.formDialogShow = true;
      if (this.$route.query.id) {
        this.information = {
          operation: 'delete',
          icon: 'warn',
          subTitle: `是否放弃编辑，返回上级页面？`,
        };
      } else {
        this.information = {
          operation: 'delete',
          icon: 'warn',
          subTitle: `是否放弃新增，返回上级页面？`,
        };
      }
    },
    goBack() {
      this.$router.back(-1);
    },
  },
};

</script>
<style lang="less" scope>
.btns {
  align-items: center;
  justify-content: center;
}
</style>
<style lang="less">
.info-edit {
  .el-form-item--small.el-form-item {
    margin-bottom: 30px;
  }
  .btn-form-item.el-form-item--small {
    .el-form-item__content {
      margin-left: 0 !important;
    }
  }
  .lng-label .el-form-item__label {
    width: 50px !important;
  }
  .lng-label .el-form-item__content {
    margin-left: 50px !important;
  }
}
</style>

